// extracted by mini-css-extract-plugin
export var root = "action-icon-module--root--bb2b2";